import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { HonestyBlock } from './components/HonestyBlock';
import { PainGrid } from './components/PainGrid';
import { BigIdea } from './components/BigIdea';
import { ProductReveal } from './components/ProductReveal';
import { Mechanism } from './components/Mechanism';
import { Volumes } from './components/Volumes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { Transformation } from './components/Transformation';
import { TwentyMinutes } from './components/TwentyMinutes';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { Testimonials } from './components/Testimonials';
import { firstRun, secondRun } from './data/testimonials';
type AppProps = {
  /**
   * 'none' = Option B, no urgency (safe to launch now).
   * 'launch-price' = Option A, only with a real date and a real increase.
   */
  urgency?: 'none' | 'launch-price';
};
export function App({
  urgency = 'none'
}: AppProps) {
  return <div className="min-h-screen w-full bg-cream text-ink font-sans selection:bg-sage selection:text-white" data-id="element-0" data-mp="56m9egl55mh">
      <MetaPixel data-id="element-1" data-mp="2zn6cayzu2hoa" />
      <main data-id="element-2" data-mp="33mowttnqsqql">
        <Hero data-id="element-3" data-mp="33m5b01uz1i7a" />
        <SocialProofBar data-id="element-4" data-mp="33lx0uhq8gqzs" />
        {/* Section 3 — real quotes in data/testimonials.ts replace the
            honesty block automatically. Until then, no borrowed proof. */}
        {firstRun.length > 0 ? <Testimonials testimonials={firstRun} kicker="From families using it" title="Three weeks in, nothing had to be restarted" background="white" data-id="element-5" data-mp="3dlwa6guh8ldp" /> : <HonestyBlock data-id="element-6" data-mp="sssrer5goibg" />}
        <PainGrid data-id="element-7" data-mp="36859fxwiety" />
        <BigIdea data-id="element-8" data-mp="35oz0whm5evr" />
        <ProductReveal data-id="element-9" data-mp="356ttacz3qbp" />
        <Mechanism data-id="element-10" data-mp="34nd1wz277z9" />
        <Volumes data-id="element-11" data-mp="38b2ol1dva8p" />
        <Bonuses data-id="element-12" data-mp="3ud1dv4v0xg8i" />
        <Urgency variant={urgency} data-id="element-13" data-mp="3udkqq75thefo" />
        <Pricing data-id="element-14" data-mp="3ucje3y95kjvu" />
        <Transformation data-id="element-15" data-mp="3uf5g7id9y76o" />
        {/* Section 12 — the run that validates the price card. */}
        {secondRun.length > 0 ? <Testimonials testimonials={secondRun} kicker="What they actually use" title="The pieces that stayed in use" background="cream" data-id="element-16" data-mp="851h73xjhxs0" /> : <TwentyMinutes data-id="element-17" data-mp="3bncpxvplb02n" />}
        {secondRun.length > 0 && <TwentyMinutes data-id="element-18" data-mp="3qb7hv9vrx0eo" />}
        <Guarantee data-id="element-19" data-mp="3qbfwp7bgifsi" />
        <Faq data-id="element-20" data-mp="3qbzgktko3e96" />
        <CostOfInaction data-id="element-21" data-mp="3qcr37ewae1nb" />
        <Close urgency={urgency} data-id="element-22" data-mp="3qd0tl3l8uatj" />
      </main>
      <Footer data-id="element-23" data-mp="3ljg27ue5of3b" />
    </div>;
}